const ReferralCodeConfig = {
  ParamName: 'referral_code',
  LocalStorageKey: 'referralCodeTemporal',
};

export default ReferralCodeConfig;
